import { makeStyles } from "@material-ui/core";

import { LevelIcon } from "./LevelIcon";
import { Cooperation } from "../../gardener/gardener.model";

const useStyles = makeStyles({
    root: {
        fontSize: "14px",
        fontWeight: 400,
        color: "#4A4A4A",
        textAlign: "center",

        "& > div": {
            display: "inline-flex",
            alignItems: "center",

            "& > span": {
                fontWeight: 600,    
            },

            "& > svg": {
                marginLeft: "4px",
                fontSize: "24px",
            },
        },
    },
});

export interface MotivationProps {
    cooperation: Cooperation;
}

export const Motivation = (props: MotivationProps) => {
    const classes = useStyles();
    const { cooperation } = props;

    return (
        <div className={classes.root}>
            {cooperation.level !== "platin" ? (
                <>
                    Løs {cooperation.tasksUntilNextLevel} {cooperation.tasksUntilNextLevel !== 1 ? "opgaver" : "opgave"} for
                    at nå <NextLevel cooperationLevel={cooperation.level} />
                </>
            ) : (
                <>
                    Du har nået det højeste niveau <div>– fortsæt den gode indsats!<LevelIcon cooperationLevel="platin" /></div>
                </>
            )}
        </div>
    );
};

interface NextLevelIconProps {
    cooperationLevel: Exclude<Cooperation["level"], "platin">;
}

export const NextLevel = (props: NextLevelIconProps) => {
    const { cooperationLevel } = props;

    const nextCooperationLevel = ((): Exclude<Cooperation["level"], "bronze"> => {
        switch ( cooperationLevel ) {
            case "bronze": return "silver";
            case "silver": return "gold";
            case "gold": return "platin";
        }
    })();

    const nextLevelText = (() => {
        switch ( nextCooperationLevel ) {
            case "silver": return <span>Sølv</span>;
            case "gold": return <span>Guld</span>;
            case "platin": return <span>Platin</span>;
        }
    })();

    return (
        <div>
            {nextLevelText}<LevelIcon cooperationLevel={nextCooperationLevel} />
        </div>
    );
}
